import React, { useEffect, useState } from "react";
import { getPage } from "../api/storefront";
import BlockRenderer from "../Components/BlockRenderer/BlockRenderer";
import Seo from "../Components/Seo/Seo";
import { useSiteSeo } from "../context/SiteSeoContext";
import { truncateMetaDescription } from "../utils/seoText";
import { usePrerenderReady } from "../utils/prerenderReady";

export default function Career() {
  const [page, setPage] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const siteCtx = useSiteSeo();

  useEffect(() => {
    let cancelled = false;
    getPage("career")
      .then((data) => {
        if (!cancelled) setPage(data);
      })
      .catch(() => {
        if (!cancelled) setPage(null);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  usePrerenderReady(loaded);

  const titleSuffix = siteCtx.organization_name?.trim()
    ? ` | ${siteCtx.organization_name.trim()}`
    : " | Gem Fashion Studios";
  const titleBase = page?.title?.trim() || "Careers";
  const description = page?.meta_description?.trim()
    ? truncateMetaDescription(page.meta_description.trim())
    : "Join Gem Fashion Studios and help customers discover designer rental fashion for every occasion.";

  if (!loaded) return null;

  return (
    <>
      <Seo title={`${titleBase}${titleSuffix}`} description={description} canonicalPath="/career" />
      {page?.content?.length ? (
        <BlockRenderer content={page.content} />
      ) : (
        <main className="staticPage careerPage">
          <section className="staticPage__hero">
            <p className="staticPage__eyebrow">Careers</p>
            <h1>Work with Gem Fashion Studios</h1>
            <p>
              We are always interested in stylists, operations teammates, content creators, and retail
              talent who care about service, detail, and occasion wear.
            </p>
            <a href="mailto:gemboutiqueinquiries@gmail.com?subject=Career%20at%20Gem%20Fashion%20Studios">
              Send your profile
            </a>
          </section>
        </main>
      )}
    </>
  );
}
